module.exports = __webpack_public_path__ + "img/ready-go-play.6b441cdc.png";